import React from 'react'
import { Route } from 'react-router-dom'
import PropTypes from 'prop-types'

// Used both on server and client
const UniversalRoute = ({ component: Component, initialData, ...rest }) => (
  <Route
    {...rest}
    render={props => (
      <Component {...props} {...rest} initialData={initialData} />
    )}
  />
)

UniversalRoute.propTypes = {
  component: PropTypes.func.isRequired,
  initialData: PropTypes.oneOfType([PropTypes.bool, PropTypes.object])
}

export default UniversalRoute



// WEBPACK FOOTER //
// ./src/components/UniversalRoute/UniversalRoute.js